import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryHotelsPicturesData = Offers.Endpoints.HotelsPictures;

interface UseQueryHotelsPicturesOptions {
  initialData?: UseQueryHotelsPicturesData;
}

interface UseQueryHotelsPicturesParameters {
  hotelId: number | null;
}

const useQueryHotelsPictures = (
  parameters: UseQueryHotelsPicturesParameters,
  options?: UseQueryHotelsPicturesOptions,
) => {
  const locale = getLocale();

  return useQuery<UseQueryHotelsPicturesData>(
    [QueryId.HOTELS_PICTURES, parameters, locale],
    async () => {
      return await fetch(`/api/hotels/pictures?hotelId=${parameters.hotelId}`, {
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
        },
        method: 'GET',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .then(response => response.result)
        .catch(error => {
          console.error('hooks.useQueryHotelsPictures', error);

          throw error;
        });
    },
    {
      enabled: !!parameters.hotelId,
      initialData: options?.initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );
};

export default useQueryHotelsPictures;
